<div class="container">
  <div class="row">
    <div class="col-12 title">
      <h3>{{'COMMON.PRODUCT_RETIRED.TITLE' | translate }}</h3>
      <span class="close" (click)="close()">
        <svg-icon key="icon-close" class='image' aria-label="close"></svg-icon>
      </span>
    </div>
  </div>

<div class="row">
  <div class="col-12 mb-3" *ngFor="let product of productsRetired">
    <p>{{'COMMON.PRODUCT_RETIRED.MESSAGE' | translate: { product: product.product.title,  reason: product.reason }  }}</p>
  </div>
</div>

</div>
